import BaseApi from "../../../services/Api";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import React, {useEffect, useState} from "react";
import Tooltip from "../../Popups/Tooltip";
import {Modal, Spinner} from "react-bootstrap";
import Button from "../../Layout/Button";
import style from "./style.module.css"


const ModalDonation = ({
  idDonation, onUpdate, onCreate, children
}) => {
  const [isLoading, setLoading] = React.useState(true);
  const [isSaving, setSaving] = React.useState(true);
  const [isShow, setShowModal] = React.useState(false);

  const [name, setName] = useState('');
  const [moreInfo, setMoreInfo] = useState('');
  const [icon, setIcon] = useState(null);
  const [updateIcon, setUpdateIcon] = useState(null);
  const [description, setDescription] = React.useState('');
  
  const [currentImage, setCurrentImage] = useState(null);

  const buildFormData = () =>{
    const formData = new FormData();
    if(name!=undefined){

      formData.append("name", name)
    }
    if(moreInfo!=undefined){

      formData.append("moreInfo", moreInfo)
    }
    if(description!=undefined){
      formData.append("description", description)

    }
    
    if(idDonation){
      formData.append('_method', 'PUT')
      if (updateIcon) {
        formData.append("icon", updateIcon);
    }
    }else{

      if (icon){
        formData.append("icon", icon)
      
  
      }
    }
    return formData
  }

  const formData = buildFormData();

  const onSave = () => {
    Swal.fire({
      title: 'Certeza que deseja salvar?',
      text: "Você não conseguirá reverter isso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: "#198754",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitData();
      } else if (
          result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Operação cancelada!',
          showConfirmButton: false,
          timer: 1500
        })
      }
    })
  }


  const submitData = () => {
    setSaving(true);
    if (idDonation) {
      BaseApi.post(`/doacoes/${idDonation}`, formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Doação criada com sucesso!');
        onUpdate && onUpdate(res.data);
      }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados salvos com sucesso!',
          showConfirmButton: false,
          timer: 1500
        })
      }).catch(err => {
        Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || `${err?.response?.data?.message}`, 'error');
        setSaving(false);
      })
    }
    else {
      BaseApi.post('/doacoes', formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Informação de doação atualizada com sucesso');
        onCreate && onCreate(res.data);
      }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados salvos com sucesso!',
          showConfirmButton: false,
          timer: 1500
        })
      }).catch(err => {
        Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || `${err?.response?.data?.message}`, 'error');
        setSaving(false);
      })
    }
  }

  const handleClose = () => {
    setShowModal(false);
  }

  const handleChangeIcon = (e) => {
    const selectedIcon = e.target.files[0];
    if (idDonation){
      if (selectedIcon)  {
        setUpdateIcon(selectedIcon);
        setCurrentImage(selectedIcon);
      }
    }
    else {
      if (selectedIcon)  {
        setIcon(selectedIcon);
        setCurrentImage(selectedIcon);
      }
    }
};

  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/doacoes${idDonation ? `/${idDonation}` : ''}`).then(res => {
      let data = res.data;
      setName(data.name);
      setMoreInfo(data.moreInfo);
      setDescription(data.description);
      setIcon(data.icon)
      setCurrentImage(data.icon)
      setLoading(false);
      setSaving(false);
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar esta ação ou a doação não foi encontrada.', 'error');
      setShowModal(false);
    })
  }

  useEffect(() => {
    if(isShow) {
      requestData();
    } else {
      setName('');
      setMoreInfo('');
      setDescription('');
      setIcon(null);
      setUpdateIcon(null);
      setLoading(true);
      setSaving(true);
    }
  }, [isShow])

  return (
    <>
      {children &&
        React.cloneElement(children, { onClick: (e) => setShowModal(true) })}
      {!children && (
        <Tooltip text={idDonation ? "Editar doação" : "Criar doação"}>
          <button
            className={`btn btn-${idDonation ? "warning" : ""} text-white fa-bold`}
            onClick={(e) => setShowModal(true)}
          >
            <i className={`bi bi-${idDonation ? "person-gear" : "plus"}`}></i>
          </button>
        </Tooltip>
      )}
      <Modal
        centered
        scrollable
        onHide={handleClose}
        show={isShow}
        animation={true}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>{idDonation ? "Editar" : "Criar"} Doação</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center">
            {isLoading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
          {!isLoading && (
            <>
              <div className="row">
                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="name">Nome </label> 
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Insira o nome"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    
                  />
                </div>

                <div className="form-group mb-3">
                  <div>
                  <label className={style.required} htmlFor="name">Description </label> 

                    <textarea 
                      name="text" 
                      id="description" 
                      cols="30" 
                      rows="5"
                      className="form-control"
                      placeholder="Insira a descrição"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="link">Informações Adicionais </label>
                  <input
                    type="link"
                    className="form-control"
                    id="link"
                    placeholder="Insira a informação "
                    value={moreInfo}
                    onChange={(e) => setMoreInfo(e.target.value)}
                  />
                </div>


                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="icon">Icone </label>

                  <input type="file" accept="icon/*"
                  className="form-control"
                  
                  onChange={handleChangeIcon} />
                  
                  {idDonation ? (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      <img
                        src={currentImage instanceof File ? URL.createObjectURL(currentImage) : currentImage}
                        alt="currentImage"
                        style={{ minWidth: 250, width: 350, objectFit: 'cover' }}
                      />
                    </div>
                  ) : 
                    null
                  }

                  {currentImage && !idDonation && (
                    <div className="d-flex justify-content-center align-items-center mt-2">
                      {idDonation ? <img src={currentImage} alt="currentImage" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                        : <img src={URL.createObjectURL(currentImage)} alt="currentImage" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                      }
                      </div>
                    )
                  }
                </div>


              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center w-100">
            <div className="d-block me-auto"></div>
            <div className="d-block ms-auto">
              <button
                className="btn btn-danger text-white me-2"
                onClick={handleClose}
              >
                Close
              </button>
              <Button
                loading={isSaving}
                onClick={onSave}
                className="btn btn-success text-white"
              >
                {idDonation ? "Editar" : "Criar"}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalDonation;